import sortBy from "lodash/sortBy";

export const coursesSelector = (state) => sortBy(state.courses.list, "rank");
export const courseSelector = (state) => state.courses.course;
export const lessonSelector = (state) => state.courses.lesson;
export const assessmentSelector = (state) => state.courses.assessment;
export const assessmentResultSelector = (state) =>
  state.courses.assessmentResult;
